
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.5 62C53.27 62 62 53.27 62 42.5S53.27 23 42.5 23 23 31.73 23 42.5 31.73 62 42.5 62zm0 6C56.583 68 68 56.583 68 42.5S56.583 17 42.5 17 17 28.417 17 42.5 28.417 68 42.5 68z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.918 57.581a3 3 0 014.242 0l19.961 19.961a3 3 0 11-4.242 4.243l-19.961-19.96a3 3 0 010-4.244z"}})])
          )
        }
      }
    